import { render, staticRenderFns } from "./FreeSubscriptionSettings.vue?vue&type=template&id=6046df46&scoped=true&"
import script from "./FreeSubscriptionSettings.vue?vue&type=script&lang=js&"
export * from "./FreeSubscriptionSettings.vue?vue&type=script&lang=js&"
import style0 from "./FreeSubscriptionSettings.vue?vue&type=style&index=0&id=6046df46&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6046df46",
  null
  
)

export default component.exports